import React, { useEffect } from 'react';
import contactImg from '../assets/images/new/contact.jpg';
import bioImg from '../assets/images/new/biographie.jpg';
import cvImg from '../assets/images/new/cv.jpg';
import coloImg from '../assets/images/new/colophon.jpg';
import LinkTitle from './ListTitles';
import ListContact from './ListContact';

export default function List({ titlesList, img, urlPath, isBig, setIsHover }) {
  const checkPage = () => {
    if (/realisation/.test(urlPath)) {
      return 'realisations';
    }
    if (/etude/.test(urlPath)) {
      return 'etudes';
    }
    if (/actu/.test(urlPath)) {
      return 'actualites';
    }
    if (/info/.test(urlPath)) {
      return 'infos';
    }
  };

  const hoverEffect = (e) => {
    document
      .querySelectorAll(`.${e.currentTarget.classList[1]}`)
      .forEach((a) => {
        a.classList.add('active');

        if (!e.currentTarget.classList.contains('imgLink')) {
          if (a.classList.contains('imgLink')) {
            a.scrollIntoView({
              behavior: 'smooth',
              block: 'end',
              inline: 'nearest',
            });
          }
        }
        if (e.currentTarget.classList.contains('imgLink')) {
          if (!a.classList.contains('imgLink')) {
            a.scrollIntoView({
              behavior: 'smooth',
              block: 'end',
              inline: 'nearest',
            });
          }
        }
      });
  };

  const outEffect = (e) => {
    document
      .querySelectorAll(`.active`)
      .forEach((a) => a.classList.remove('active'));
  };

  useEffect(() => {
    const allA = document.querySelectorAll('.link-list');

    allA.forEach((a) => a.addEventListener('mouseover', hoverEffect));
    allA.forEach((a) => a.addEventListener('mouseout', outEffect));
    // window.addEventListener('mouseover', hoverEffect);

    return () => {
      allA.forEach((a) => a.removeEventListener('mouserover', hoverEffect));
      allA.forEach((a) => a.removeEventListener('mouseout', outEffect));
    };
  }, [urlPath]);

  return (
    <div className={isBig ? 'hiden list' : 'list'}>
      <ul className="nav-links">
        {!titlesList[0].email ? (
          titlesList.map((title, index) => (
            <LinkTitle
              img={img}
              title={title}
              key={index}
              urlPath={checkPage()}
              setIsHover={setIsHover}
            />
          ))
        ) : (
          <>
            <ListContact
              imgPath={contactImg}
              img={img}
              page="Contact"
              setIsHover={setIsHover}
            />
            <ListContact
              imgPath={bioImg}
              img={img}
              page="Biographie"
              setIsHover={setIsHover}
            />
            <ListContact
              imgPath={cvImg}
              img={img}
              page="CV"
              setIsHover={setIsHover}
            />
            <ListContact
              imgPath={coloImg}
              img={img}
              page="Colophon"
              setIsHover={setIsHover}
            />
          </>
        )}
      </ul>
    </div>
  );
}
